module.exports = __webpack_public_path__ + "img/laos_logo.30869308.png";